import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import { useLoaderData, useNavigation } from "react-router-dom";
import CheckoutForm from "./CheckoutForm";
import Lottie from "lottie-react";
import payment from "../../../payment.json";
import Loading from "../../Shared/Loading/Loading";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
// console.log("stripePromise:", stripePromise);

const Payment = () => {
  const booking = useLoaderData();
  const navigation = useNavigation();

  const { mobileName, price } = booking;

  console.log("booking:", booking);

  if (navigation.state === "loading") {
    return <Loading></Loading>;
  }

  return (
    <div className="flex flex-col md:flex-row-reverse justify-center items-center gap-10 md:gap-16 w-[88%] mx-auto md:mr-10 h-[95vh] md:h-[95vh] mt-8 md:mt-0 mb-16 md:mb-0 md:my-0">
      <div className="w-[100%] mx-auto lg:w-[45%]"
        data-aos="fade-left"
        data-aos-duration="2500"
      >
        <Lottie animationData={payment} loop={true} />
      </div>

      <div className="md:mt-0"
        data-aos="zoom-in"
        data-aos-duration="2500"
      >
        <h3 className="text-2xl font-semibold mb-3 text-center my-transition-5">
          Online Payment Process
        </h3>

        <p className="text-lg text-center">
          Please pay
          <span className="font-bold text-orange-500 mx-2">
            BDT {price}
          </span>
          for
          <span className="font-bold mx-2 text-cyan-600">{mobileName}</span>
        </p>
        <div
          className="mt-5 md:mx-[-30px] lg:mx[-20px] mx-auto rounded-xl uncommon bg-base-100 shadow-md p-5 md:p-6"
          title="Example Visa Card: (4242 4242 4242 4242) + (02/27) + (123) + (12345)"
        >
          <Elements stripe={stripePromise}>
            <CheckoutForm booking={booking} />
          </Elements>
        </div>
      </div>
    </div>
  );
};

export default Payment;
